var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclude(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.261 21.3343C18.915 23.7537 15.9091 25 12.4634 25C9.0176 25 6.08505 23.7537 3.66569 21.3343C1.24634 18.915 0 15.9824 0 12.5367C0 9.09092 1.24634 6.08505 3.66569 3.66569C6.08505 1.24633 9.0176 0 12.4634 0C15.9091 0 18.8417 1.24633 21.261 3.66569C23.7537 6.08505 24.9267 9.09092 24.9267 12.5367C24.9267 15.9824 23.6804 18.915 21.261 21.3343ZM20.6747 8.79845L10.3375 19.209L4.25244 13.124L5.93866 11.4377L10.3375 15.8366L18.9885 7.18555L20.6747 8.79845Z",
    fill: "#277C82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclude);
export default __webpack_public_path__ + "static/media/Exclude.0883af70c3c83643188565fc2e9010c6.svg";
export { ForwardRef as ReactComponent };